import React from "react";
import { connect } from "react-redux";
import * as ErrorAction from "../../../redux/action/error-action";
import { SkyLightStateless } from "react-skylight";
import RedirectIfNotLogged from "../../menu/redirect-if-not-logged";
import Header from "../../header";
import { styles } from "../../menu/styles";
import { CircularProgress, RaisedButton, TextField } from "material-ui";
import Select from "react-select";
import { Constants as Contants, Constants } from "../../../constants";
import request from "../../../config/axios-config";
import * as validator from "../../../general/validators/validator";

class ReportsAddArticleDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: true,
      error: {},

      productOps: [],
      products: [],
      productId: undefined,
      details: "",
      price: "",
      quantity: "",
      vat: Constants.DEFAULT_VAT
    };
  }

  componentDidMount() {
    this.setState({ loadingData: true });
    request({ url: Constants.SERVER_ENDPOINT + "/product/all", method: "get" })
      .then(products => {
        this.setState({
          products: products.data,
          productOps: products.data.map((t, i) => {
            return { value: t.id, label: t.name };
          }),
          loadingData: false,
          errorLoading: false
        });
      })
      .catch(err => {
        this.setState({
          loadingData: false,
          errorLoading: true
        });
      });
  }

  componentWillUnmount() {
    this.props.hideError();
  }

  closeModal = shouldRefresh => {
    this.setState({
      modalIsOpen: false
    });
    this.props.hideError();
    this.props.onCancel(shouldRefresh);
  };

  onAddArticleClicked = () => {
    let error = this.validateArticle();
    if (error) {
      this.setState({
        error: error
      });
      return;
    }
    this.setState({
      error: {}
    });

    let body = {
      product: { id: this.state.productId },
      pricePerUnit: this.state.price,
      quantity: this.state.quantity,
      vat: this.state.vat,
      details: this.state.details
    };

    request({
      url: Contants.SERVER_ENDPOINT + "/report/article",
      method: "POST",
      data: body
    })
      .then(response => {
        this.closeModal(true);
      })
      .catch(err => {
        this.setState({
          error: { savingError: true }
        });
      });
  };

  validateArticle = () => {
    let found = false;
    let error = {};
    let price = this.state.price;
    if (validator.isEmpty(price) || price === 0 || price === "0" || price < 0) {
      found = true;
      error.price = "Lipseste pretul sau este 0";
    }
    let quantity = this.state.quantity;
    if (
      validator.isEmpty(quantity) ||
      quantity === 0 ||
      quantity === "0" ||
      quantity < 0
    ) {
      found = true;
      error.quantity = "Lipseste cantitatea sau este 0";
    }
    let vat = this.state.vat;
    if (validator.isEmpty(vat) || vat < 0) {
      found = true;
      error.vat = "Lipseste TVA-ul sau este negativ";
    }
    if (validator.isEmpty(this.state.productId)) {
      found = true;
      error.product = "Lipsa produs";
    }
    if (!found) {
      return null;
    }
    return error;
  };

  onProductChanged = val => {
    let productPrice = null;
    this.state.products.forEach(t => {
      if (t.id === val && t.price > 0) {
        productPrice = t.price;
      }
    });

    if (productPrice !== null && productPrice !== undefined) {
      this.setState({
        productId: val,
        price: productPrice,
        pricePredefined: true
      });
    } else {
      this.setState({
        productId: val,
        pricePredefined: false
      });
    }
  };

  render() {
    return (
      <div>
        <RedirectIfNotLogged />
        <SkyLightStateless
          isVisible={this.state.modalIsOpen}
          dialogStyles={styles.defaultDialogStyles}
          onCloseClicked={() => this.closeModal(false)}
          onOverlayClicked={() => this.closeModal(false)}
          title={<Header title={"Adauga articol"} />}
        >
          <div
            style={{
              marginTop: "20px",
              marginLeft: "20px",
              marginRight: "20px"
            }}
          >
            {this.state.errorLoading ? (
              <div style={{ textAlign: "center" }}>
                <h1>A aparut o problema. Va rog reincercati!</h1>
              </div>
            ) : this.state.loadingData ? (
              <div style={{ textAlign: "center" }}>
                <CircularProgress />
              </div>
            ) : (
              <table className="table  table-hover">
                <tbody>
                  <tr>
                    <td>
                      <strong>Produsul: </strong>
                    </td>
                    <td>
                      <Select
                        ref="stateSelect"
                        autoFocus
                        options={this.state.productOps}
                        simpleValue
                        clearable={true}
                        name="selected-state"
                        disabled={false}
                        value={this.state.productId}
                        onChange={this.onProductChanged}
                        searchable={true}
                      />

                      <div>
                        {this.state.error.product && (
                          <div
                            style={{
                              fontSize: "12px",
                              color: "rgb(244, 67, 54)",
                              marginTop: "5px"
                            }}
                          >
                            {this.state.error.product}
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <strong>Detalii:</strong>
                    </td>
                    <td>
                      <TextField
                        style={{ width: 200 }}
                        hintText="Detalii"
                        type={"text"}
                        value={this.state.details}
                        rowsMax={2}
                        onChange={e => {
                          this.setState({
                            details: e.target.value
                          });
                        }}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <strong>Pret:</strong>
                    </td>
                    <td>
                      <div className="field-line">
                        {this.state.pricePredefined ? (
                          <TextField
                            style={{ width: 200 }}
                            disabled={true}
                            value={this.state.price}
                            hintText={this.state.price}
                          />
                        ) : (
                          <TextField
                            style={{ width: 200 }}
                            hintText="Pret"
                            type={"number"}
                            errorText={this.state.error.price}
                            value={this.state.price}
                            onChange={e => {
                              this.setState({
                                price: e.target.value
                              });
                            }}
                          />
                        )}
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <strong>TVA: </strong>
                    </td>

                    <td>
                      <TextField
                        style={{ width: 200 }}
                        hintText="TVA"
                        type={"number"}
                        errorText={this.state.error.vat}
                        value={this.state.vat}
                        onChange={e => {
                          this.setState({
                            vat: e.target.value
                          });
                        }}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <strong>Cantitate: </strong>
                    </td>
                    <td>
                      <TextField
                        style={{ width: 200 }}
                        hintText="Cantitatea"
                        type={"number"}
                        errorText={this.state.error.quantity}
                        value={this.state.quantity}
                        onChange={e => {
                          this.setState({
                            quantity: e.target.value
                          });
                        }}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td />
                    <td>
                      <RaisedButton
                        style={{ marginTop: "20px" }}
                        primary
                        label={"Salveaza"}
                        onClick={this.onAddArticleClicked}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            )}

            <div style={{ textAlign: "center" }}>
              {this.state.error.savingError && (
                <strong style={{ color: "#FF0000" }}>
                  A aparut o eroare! Va rog reincercati!
                </strong>
              )}
            </div>
          </div>
        </SkyLightStateless>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    showError: text => dispatch(ErrorAction.showError(text)),
    hideError: () => dispatch(ErrorAction.hideError())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportsAddArticleDialog);
